
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import { ModeAwareStorageManager } from '@/lib/managers/ModeAwareStorageManager';
import { useGameMode } from "@/contexts/GameModeContext";
import { modeAwareStorage } from '@/lib/managers/ModeAwareStorageManager';

interface ProgressTrackerProps {
  currentLevel: number;
  completedLevels: number[];
  failedLevel?: number;
}

export const ProgressTracker = ({ currentLevel, completedLevels: propCompletedLevels, failedLevel }: ProgressTrackerProps) => {
  const { currentMode } = useGameMode();
  const isPracticeMode = currentMode === 'practice';
  
  // Get completed levels from cookies if available
  // Use mode-aware storage for completed levels
  const savedCompletedLevels = modeAwareStorage.getCookie('completed_levels');
  const completedLevels = savedCompletedLevels ? 
    JSON.parse(savedCompletedLevels) : propCompletedLevels;

  // Levels are 1-4, corresponding to word lengths 3-6
  const levels = [1, 2, 3, 4];

  return (
    <div className="py-2 px-4 w-full bg-black/80 rounded-t-xl shadow-lg mb-0">
      <div className="flex items-center justify-center space-x-1">
        {levels.map((level, index) => (
          <div key={level} className="flex items-center">
            <div
              className={cn(
                "w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium border-2",
                failedLevel === level
                  ? "bg-red-500 border-red-600 text-white"
                  : level < currentLevel
                  ? "bg-success border-success text-white"
                  : level === currentLevel
                  ? isPracticeMode ? "bg-purple-500 border-purple-600 text-white" : "bg-red-500 border-red-600 text-white"
                  : "bg-gray-700 border-gray-600 text-gray-400"
              )}
            >
              {failedLevel === level ? <X className="w-3 h-3" /> : level}
            </div>
            {index < levels.length - 1 && (
              <div
                className={cn(
                  "h-0.5 w-6",
                  level < currentLevel - 1
                  ? "bg-success"
                  : level === currentLevel - 1
                  ? "bg-success"
                  : level === currentLevel
                  ? isPracticeMode ? "bg-purple-500" : "bg-red-500"
                  : "bg-gray-700"
                )}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
